import { environment } from '../../../environments/environment';

export function initMetaPixel(): void {
  if (!environment.production) return;

  if (!environment.metaPixelId) {
    console.warn('Meta Pixel ID is not set. Skipping Meta Pixel initialization.');
    return;
  }

  const w = window as any;

  if (w.fbq) return;

  const fbq: any = function (this: any, ...args: unknown[]): void {
    fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
  };

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  w.fbq = fbq;
  w._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  w.fbq('init', environment.metaPixelId);
  w.fbq('track', 'PageView');
}
